<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading full-character-formatting" id="dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">This book is dedicated to my best friend, partner, husband.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">Thank you for encouraging me to follow my dreams, for your unwavering support in all things, and for believing in me when I didn’t even believe in myself.</p>
</div>
<hr class="implicit-break"/>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">You have my heart always.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1115e072